export const MIN_USERNAME_LENGTH = 8;

export const USERNAME_NOTE = `Choose a unique username (${MIN_USERNAME_LENGTH}-16 characters) to sign in to your FV Bank account. It may contain letters, numbers, periods (.), and underscores (_) only.`;
